/* eslint-disable no-undef */
import React from "react"

import { OutboundLink } from 'gatsby-plugin-google-analytics'
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

import facebookLight from "../../images/social/facebook-light.svg"
import facebookDark from "../../images/social/facebook-dark.svg"
import facebookBlack from "../../images/social/facebook-black.svg"

import styles from "./socialLinks.module.scss"

import { FACEBOOK_URL } from "../../constants.js"

const images = {
  facebookLight,
  facebookDark,
  facebookBlack,
}

const FacebookLink = ({ variant, share }) => {
  let Wrapper = ({ children }) => (
    <OutboundLink href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
      {children}
    </OutboundLink>
  )

  if (share) {
    Wrapper = ({ children }) => (
      <button
        style={{ cursor: 'pointer' }}
        onClick={() => {
          trackCustomEvent({
            category: "Social",
            action: "Share",
            label: "Facebook",
            value: null
          })

          FB.ui({
            method: 'share',
            href: 'https://tillfinancial.io/'
          }, function (response) { })
        }}
        onKeyDown={() => {
          trackCustomEvent({
            category: "Social",
            action: "Share",
            label: "Facebook",
            value: null
          })

          FB.ui({
            method: 'share',
            href: 'https://tillfinancial.io/'
          }, function (response) { })
        }} 
        tabindex="0"
      >
        {children}
      </button>
    )
  }

  return (
    <Wrapper>
      <img
        className={styles.img}
        src={images[`facebook${variant}`]}
        alt="Facebook Logo"
        layout="fixed"
      />
    </Wrapper>
  )
}

export default FacebookLink
